import { Component, Input, OnDestroy } from '@angular/core';
import { CountryService } from '../../../@core/mock/country.service';
import { takeWhile } from 'rxjs/operators';
import { Information } from '../../../@core/data/country';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-country-informations',
  styleUrls: ['./country-informations.component.scss'],
  template: `
    <div class="summary-container">
      <div *ngFor="let item of countryInformationSummary">
        <div style="width:250px; ">
          <div>{{ item.title }}</div>
          <div class="h6">{{ item.value }}</div>
        </div>
      </div>
    </div>
  `,
})
export class CountryInformationsComponent implements OnDestroy {
   //@Input() summary: {title: string; value: any}[];

   private alive = true;
   countryName: string;
   countryType: string;
   countryInformationSummary: Information[] = [];

   constructor(private countryService: CountryService,
    private route: Router,) {

      this.countryType = this.route.getCurrentNavigation().extras.state.countryType;
      this.countryName = this.route.getCurrentNavigation().extras.state.countryName;

      this.countryService.getCountryInformation(this.countryName)
      .pipe(takeWhile(() => this.alive))
      .subscribe((countriesCategories) => {
        this.countryInformationSummary = countriesCategories;
      });
    }

    ngOnDestroy(){

    }
}
